module.exports = __webpack_public_path__ + "static/unSignupTip2.04701034.png";